import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setPermissions } from "../redux/slices/permissionsSlice"
import { RootState } from "../redux/store"

const PermissionsInitializer = () => {
  const dispatch = useDispatch()
  const currentUser = useSelector((state: RootState) => state.user)

  useEffect(() => {
    if (currentUser.profile?.entity_no && currentUser.profile?.permissions) {
      const roleSlugs = currentUser.profile.permissions.map((perm) => perm.slug)
      dispatch(setPermissions(roleSlugs))
    }
  }, [currentUser.profile?.entity_no])

  return null
}

export default PermissionsInitializer
